import React from 'react';
import { UserRank } from '../types';
import { getRankRingParams } from './utils/rankUtils';

interface LegionAvatarWrapperProps {
    rank?: UserRank;
    children: React.ReactNode;
    className?: string;
}

export const LegionAvatarWrapper: React.FC<LegionAvatarWrapperProps> = ({ rank, children, className }) => {
    if (rank !== 'legion') {
        return <>{children}</>;
    }

    // Legion Aura Gradient
    return (
        <div className={`relative p-[3px] rounded-full bg-linear-to-tr from-emerald-950 via-emerald-400 to-emerald-950 ${className || ''} animate-[pulse_3s_ease-in-out_infinite]`}>
            <div className="rounded-full overflow-hidden h-full w-full border border-black/10 dark:border-white/10">
                {children}
            </div>
            <div className="absolute inset-0 rounded-full bg-green-500/20 blur-md -z-10" />
        </div>
    );
};
